<template>
	<div>
		<!-- 新增、编辑合同 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false"
			 :modal-append-to-body="false" :before-close="handleClose">
			<el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
				<el-form-item prop="name" label="合同名称">
					<el-input :disabled="isXz==3||title=='查看合同'" v-model="formData.name" placeholder="请输入合同名称"></el-input>
				</el-form-item>
				<el-form-item prop="number" label="合同编号">
					<el-input :disabled="isXz==3||title=='查看合同'" v-model="formData.number" placeholder="请输入合同编号"></el-input>
				</el-form-item>
				<div style="display: flex;justify-content: space-between;">
					<el-form-item prop="type" label="合同类型">
						<el-select :disabled="isXz==3||title=='查看合同'" style="width: 100%;" v-model="formData.type" placeholder="请选择合同类型">
							<el-option label="托管协议" value="托管协议"></el-option>
							<el-option label="租赁合同" value="租赁合同"></el-option>
							<el-option label="服务合同" value="服务合同"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="signingDate" label="签约日期">
						<el-date-picker :disabled="isXz==3||title=='查看合同'" type="date" placeholder="选择签约日期" v-model="formData.signingDate"
							style="width:100%;">

						</el-date-picker>
					</el-form-item>
				</div>

				<el-form-item prop="startTime" label="合同期限">
					<el-col :span="11">
						<el-date-picker :disabled="isXz==3||title=='查看合同'" type="date" placeholder="选择日期" v-model="formData.startTime"
							style="width: 100%;"></el-date-picker>
					</el-col>
					<el-col class="line" :span="2" style="text-align: center;">-</el-col>
					<el-col :span="11">
						<el-date-picker :disabled="isXz==3||title=='查看合同'" type="date" placeholder="选择时间" v-model="formData.endTime" style="width: 100%;">
						</el-date-picker>
					</el-col>
				</el-form-item>
				<div style="display: flex;justify-content: space-between;">
					<el-form-item prop="contractor" label="签约单位">
						<!-- <el-autocomplete v-model="formData.company" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" value-key="unitName"
						      clearable @clear="clearSearch" ref="myAutocomplete"></el-autocomplete> -->
						<!-- {{formData}} -->
						<el-autocomplete :disabled="isXz==3||title=='查看合同'" v-model="formData.contractor" :fetch-suggestions="querySearchAsync"
							placeholder="请输入签约单位" value-key="unitName" clearable @clear="clearSearch"
							ref="myAutocomplete"></el-autocomplete>
						<!-- <el-select v-model="formData.contractor" placeholder="请选择签约单位">
							<el-option label="区域一" value="shanghai"></el-option>
							<el-option label="区域二" value="beijing"></el-option>
						</el-select> -->
					</el-form-item>
					<el-form-item prop="status" v-show="isShow" label="合同状态">
						<el-select :disabled="isXz==3||title=='查看合同'" v-model="formData.status" placeholder="请选择签约单位">
							<!-- <el-option label="执行中" value="执行中"></el-option> -->
							<el-option label="已终止" value="已终止"></el-option>
							<!-- <el-option label="区域二" value="beijing"></el-option> -->
						</el-select>
					</el-form-item>
				</div>
				<el-form-item prop="money" label="合同金额">
					<el-input :disabled="isXz==3||title=='查看合同'" v-model="formData.money" @blur="tableParValueChange(formData.money,'￥',2)"
						placeholder="请输入合同金额"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input :disabled="isXz==3||title=='查看合同'" v-model="formData.remarks" placeholder="请输入备注内容" type="textarea" :rows="10"></el-input>
				</el-form-item>
				<el-form-item prop="files" label="上传资料">
					<el-upload :disabled="isXz==3||title=='查看合同'" multiple action="/api/admin/bdContract/uploadContract" :on-remove="removeFile"
						:file-list="formData.files" name="file" :on-preview="uploadDown" :headers="headers"
						:on-success="uploadSuccess">
						<el-button :disabled="isXz==3||title=='查看合同'" size="small" type="primary">点击上传文件</el-button>
					</el-upload>
				</el-form-item>
				<div v-show="isShow">
					<el-form-item label="补充协议内容">
						<el-input :disabled="isXz==3||title=='查看合同'" type="textarea" rows="20" v-model="formData.contents"></el-input>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button  v-if="isXz!=3&&title!='查看合同'" type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import downloadFile from '../../../assets/js/downloadFile.js'
	export default {
		props: ["title", "dialogVisible", "obj"],
		watch: {
			"title": function(val) {
				console.log(val)
				if (val == '新增合同') {
					this.formData = {
						...this.oldFormData
					}
					this.isShow = false
				} else {
					this.formData = {
						...this.obj
					}
					if (this.formData.fileRes != null) {
						let newFiles = [];
						this.formData.fileRes.forEach((item) => {
							newFiles.push({
								name: item.name,
								url: item.url
							});
						})
						this.formData.files = newFiles;
					}
					this.isShow = true
				}
			}

		},
		data() {
			return {
				headers: {
					Authorization: localStorage.access_token
				},
				isXz:null,
				isShow: null,
				disabled: false,
				fileList: [],
				oldFormData: "", //初始数据备份
				formData: {
					region: null,
					name: null,
					startTime: null,
					endTime: null,
					signingDate: null,
					money: '',
					remarks: '',
					contractor: '',
					fileRes: [],
					files: [],
					status: null,
					contents: null,
					number:null
				},
				rules: {
					name: [{
						required: true,
						message: "合同名称不能为空",
						trigger: ["blur", "change"]
					}],
					signingDate: [{
						required: true,
						message: "签约日期不能为空",
						trigger: ["blur", "change"]
					}],
					type: [{
						required: true,
						message: "合同类型不能为空",
						trigger: ["blur", "change"]
					}],
					startTime: [{
						required: true,
						message: "合同期限不能为空",
						trigger: ["blur", "change"]
					}],
					contractor: [{
						required: true,
						message: "签约单位不能为空",
						trigger: ["blur", "change"]
					}],
					// status: [{
					// 	required: true,
					// 	message: "合同状态不能为空",
					// 	trigger: ["blur", "change"]
					// }],
					money: [{
						required: true,
						message: "合同金额不能为空",
						trigger: ["blur", "change"]
					}],
					files: [{
						required: true,
						message: "合同扫描件不能为空",
						trigger: ["blur", "change"]
					}],
					number: [{
						required: true,
						message: "合同编号不能为空",
						trigger: ["blur", "change"]
					}],
				}
			}
		},
		methods: {
			tableParValueChange(value, currency, decimals) {
				const digitsRE = /(\d{3})(?=\d)/g
				value = parseFloat(value)
				if (!isFinite(value) || (!value && value !== 0)) return ''
				currency = currency != null ? currency : '$'
				decimals = decimals != null ? decimals : 2
				var stringified = Math.abs(value).toFixed(decimals)
				var _int = decimals ?
					stringified.slice(0, -1 - decimals) :
					stringified
				var i = _int.length % 3
				var head = i > 0 ?
					(_int.slice(0, i) + (_int.length > 3 ? ',' : '')) :
					''
				var _float = decimals ?
					stringified.slice(-1 - decimals) :
					''
				var sign = value < 0 ? '-' : ''
				this.formData.money = sign + currency + head +
					_int.slice(i).replace(digitsRE, '$1,') +
					_float
					
				
			},

			
			uploadDown(obj) {
				console.log(obj)
				this.$confirm('确定下载该文件吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					downloadFile(obj);
					this.$message({
						type: 'success',
						message: '下载成功!'
					});
				}).catch(err => {
					this.$message({
						type: 'success',
						message: '取消下载!'
					});
				})

			},
			querySearchAsync(queryString, cb) {
				if (this.formData.contractor == undefined) {
					this.formData.contractor = ''
				}
				this.$http.get('/api/ownerManage/getOwners?company=' + this.formData.contractor).then(res => {
					console.log("查询所有单位信息", res.data.data);
					let result = res.data.data;
					cb(result);
				})
			},
			clearSearch() {
				this.$refs.myAutocomplete.handleFocus()
			},
			removeFile(file, fileList) {
				console.log(file)
				this.detailFileList(fileList);
			},
			//上传附件
			detailFileList(fileList) {
				let newFiles = [];
				console.log(fileList)
				fileList.forEach((item) => {
					if (item.hasOwnProperty('response')) {
						newFiles.push({
							name: item.name,
							url: item.response.data
						})
					} else {
						newFiles.push({
							name: item.name,
							url: item.url
						});
					}
				})
				this.formData.files = newFiles;
				console.log(this.formData.files)
			},
			uploadSuccess(response, file, fileList) {
				this.detailFileList(fileList);
			},
			// 取消
			cancelClick() {
				this.close();
			},
			// 确定
			confirmClick() {
				this.$refs.formData.validate((valid) => {
					if (valid) {
						let files = []
						this.formData.files.forEach(item => {
							files.push(item.url);
						})
						this.formData.files = files;
						this.$emit("addSubmit", this.formData)
					} else {
						return;
					}
							
				})
				
			},
			// 关闭之前的回调
			handleClose(done) {
				this.close();
			},
			// 关闭模态框向父组件传dialogVisible
			close() {
				this.$parent.addClose()
			}
		},
		created() {
			this.oldFormData = JSON.parse(JSON.stringify(this.formData))
				this.isXz = localStorage.getItem('roleId')
		}
	}
</script>

<style scoped="scoped">
</style>
